import React from 'react'
import PropTypes from 'prop-types'
import { addIndex, equals, forEach, mapObjIndexed, path, unless } from 'ramda'

const forEachWithIndex = addIndex(forEach)
const withValidation = Component => {
  class WithValidation extends React.Component {
    static propTypes = {
      errors: PropTypes.object
    }
    static defaultProps = {
      errors: {}
    }
    static propTypes = {
      mapper: PropTypes.object,
      handleFormSubmission: PropTypes.func
    }

    constructor (props) {
      super(props)
      this.state = {
        errors: props.errors
      }

      this.handleSubmit = e => {
        e.preventDefault()
        const mapper = this.getMapper()
        const params = this.getParamsFromMapper()

        mapObjIndexed(this.validateProps.bind(this, params), mapper)

        const { isValid, finalErrors } = this.validateSubmission()
        if (isValid) {
          params.isValid = true
          this.props.handleFormSubmission(params)
          return true
        } else {
          params.isValid = false
          params.finalErrors = finalErrors
          this.props.handleFormSubmission(params)
          return false
        }
      }
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
      this.compareProps(this.props, nextProps)
    }

    compareProps (oldProps, newProps) {
      const mapper = this.getMapper(newProps)
      mapObjIndexed(
        unless(
          (_schema, key) => equals(oldProps[key], newProps[key]),
          this.validateProps.bind(this, newProps)
        ),
        mapper
      )
    }

    getParamsFromMapper () {
      const mapper = this.getMapper()
      const keys = Object.keys(mapper)
      const items = {}
      keys.forEach(key => {
        // TODO: improve this logic seems a little hacky
        if (Array.isArray(this.props[key]) && typeof mapper[key] === 'object') {
          items[key] = []
          const errorKeys = Object.keys(mapper[key])
          this.props[key].forEach((_val, idx) => {
            errorKeys.forEach(innerKey => {
              items[key][idx] = {
                ...items[key][idx],
                [innerKey]: path([ key, idx, innerKey ], this.props)
              }
            })
          })
        } else {
          items[key] = this.props[key]
        }
      })
      return items
    }

    // TODO: consider ways to simplify this logic
    validateProps (props, schema, key) {
      if (Array.isArray(this.props[key])) {
        forEachWithIndex((val, idx) => {
          mapObjIndexed((innerVal, innerKey) => {
            if (typeof schema[innerKey] === 'function') {
              const errors = this.state.errors
              const result = schema[innerKey](props[key][idx], errors)

              // more of the same patching to make this work with cross-field validation.
              if (
                this.state.source &&
                this.state.source.key === innerKey &&
                this.state.errors[this.state.source.refField]
              ) {
                delete errors[this.state.source.refField]
                this.setState({ source: null })
              }

              // This is some invasive work to get the traveler selection errors to work correctly with the arrival/departure inputs
              // This logic and Component should not be needed when we move to Formik
              if (result.field !== innerKey) {
                errors[result.field] = result.error
                this.setState({
                  // track the source of a particular error when its not from the source
                  source: {
                    key: innerKey,
                    refField: result.field
                  }
                })
                // in case that there was an error on this field prior to this run of the validation we should remove it.
                if (
                  errors &&
                  errors[key] &&
                  errors[key][idx] &&
                  errors[key][idx][innerKey]
                ) {
                  delete errors[key][idx][innerKey]
                }
              } else {
                errors[key][idx] = {
                  ...errors[key][idx],
                  [innerKey]: result.error
                }
              }

              this.setState(errors)
            } else {
              const errors = this.state.errors
              const result = schema[innerKey].validate({
                [innerKey]: props[key][idx][innerKey]
              })

              if (!errors[key][idx]) {
                errors[key].push({})
              }

              errors[key][idx][innerKey] = result.error
              this.setState(errors)
            }
          }, props[key][idx])
        }, props[key])
      } else {
        if (typeof schema === 'function') {
          const result = schema(props)
          const errors = this.state.errors

          // To get the traveler selection errors to work correctly with the arrival/departure inputs
          if (
            this.state.source &&
            this.state.source.key === key &&
            this.state.errors[this.state.source.refField]
          ) {
            errors[this.state.source.refField] = undefined
            this.setState({ source: null })
          }

          if (result.field !== key) {
            errors[result.field] = result.error
            this.setState({
              // track the source of a particular error when its not from the source
              source: {
                key,
                refField: result.field
              }
            })
          } else {
            errors[key] = result.error
          }

          this.setState(errors)
        } else {
          const errors = this.state.errors
          const result = schema.validate({ [key]: props[key] }, errors)
          errors[key] = result.error
          this.setState(errors)
        }
      }
    }

    getMapper (props) {
      props = props || this.props
      return this.props.mapper(props)
    }

    validateErrorMessage (err) {
      if (!err) return

      return err.message
    }

    // TODO: consider ways to simplify this logic
    validateSubmission () {
      let isValid = true
      const finalErrors = {}
      const errors = this.state.errors
      const errorKeys = Object.keys(errors)
      errorKeys.forEach(key => {
        const errorObject = errors[key]

        if (Array.isArray(errorObject)) {
          const errArray = errorObject

          errArray.forEach(errObj => {
            const errKeys = Object.keys(errObj)

            errKeys.forEach(errKey => {
              const err = errObj[errKey]
              if (err) {
                isValid = false
                finalErrors[errKey] = this.validateErrorMessage(err)
              }
            })
          })
        } else {
          const err = errors[key]
          if (err) {
            isValid = false
            finalErrors[key] = err
          }
        }
      })
      return { isValid, finalErrors }
    }

    render () {
      return (
        <Component
          {...this.props}
          errors={this.state.errors}
          onSubmit={this.handleSubmit}
        />
      )
    }
  }

  WithValidation.displayName = `WithValidation${Component.displayName || Component.name || 'Component'}`
  return WithValidation
}

export default withValidation
